import { UserServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-userservicebase';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EComService } from 'src/app/ecom-services/ecom-common.service';
import { StoreServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-storeservicebase';
import { EComWebStorage } from 'src/app/ecom-services/ecom-webstorage.services';
import { EcomNetworkUtils } from 'src/app/ecom-base-entities/ecom-shared/ecom-networkutils.service';
import { strictEqual } from 'assert';
import { EcomCookies } from '../../ecom-services/ecom-cookies';

@Component({
  selector: 'app-ecom-footer',
  templateUrl: './ecom-footer.component.html',
  styleUrls: ['./ecom-footer.component.scss']
})
export class EcomFooterComponent implements OnInit {
  // component class properties
  locationSelected: any;
  userServiceBase: UserServiceBase;
  userSelectedStore: StoreServiceBase;
  cartItemCount = 0;
  upcomingOrdersCount = 0;
  qrCodeScanned = false;
  serviceType = '';
  // constructor to inject the class objects
  constructor(public router: Router, public ecomservice: EComService, public webstorage: EComWebStorage,
    private sessionSt: SessionStorageService, public cookie: EcomCookies) { }

  // component initialize and load the required data
  ngOnInit() {
    // to disable home button
    if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
      this.qrCodeScanned = this.webstorage.sessionSt_qr_code_scanned;
    }
    if (this.webstorage.sessionSt_store_back !== null && this.webstorage.sessionSt_store_back !== undefined) {
      if (!this.webstorage.sessionSt_store_back) {
        this.qrCodeScanned = true;
      }
    }
    this.ecomservice.getUserOrders();
    this.sessionSt.observe('sessionst_ordercount')
      .subscribe((value) => this.GetOrderCount(value));
    this.locationSelected = this.webstorage.sessionSt_location_selected;
    this.userServiceBase = this.webstorage.localSt_user_service_request;
    if (this.userServiceBase && this.webstorage.sessionSt_location_selected) {
      this.userServiceBase = this.webstorage.localSt_user_service_request;
      const serviceActiveId = this.webstorage.sessionSt_service_active_id;
      let userStoreIndex = -1;
      if (this.locationSelected && this.userServiceBase.selectedStoreServiceList) {
        this.serviceType = this.webstorage.sessionSt_service_type;
        const selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
          userStoreIndex = index;
          return this.ecomservice.stringCompare(obj.serviceLocationGuid, this.locationSelected.oocls_location_guid) && obj.serviceType === this.serviceType;
        });
        this.userSelectedStore = selectedStore;
        if (this.userSelectedStore && !this.userSelectedStore.serviceCompleted && this.userSelectedStore.storeCart) {
          this.cartItemCount = this.userSelectedStore.storeCart.orderItems.length;
        }
      }
    }
  }

  GetOrderCount(value) {
    this.upcomingOrdersCount = Number(this.webstorage.sessionSt_order_count);
  }

  // Method to handle to footer menu click event
  onMenuClick(type) {
    switch (type) {
      case 'PLACES':
        this.router.navigate(['home']);
        break;
      case 'SCAN':
        this.router.navigate(['scan']);
        break;
      case 'ORDERS':
        // check if user logged in then redirect to orders else redirect to login page
        //if (!this.cookie.cookie_authtoken || !this.webstorage.localSt_user_id) {
        if (this.cookie.cookie_authtoken === '') {
          this.webstorage.sessionSt_frompage = 'orders';
          this.router.navigate(['login']);
        } else {
          this.router.navigate(['orders']);
        }
        break;
      case 'PROFILE':
        // check if user logged in then redirect to profie else redirect to login page
        if (this.cookie.cookie_authtoken !== '') {
          this.router.navigate(['login']);
        } else {
          this.router.navigate(['profile']);
        }
        break;
      case 'CART':
        //if (this.qrCodeScanned) {
        //  this.router.navigate(['items']);
        //} else {
        //  this.router.navigate(['cart',this.webstorage.sessionSt_company_clicked]);
        //}
        if (this.webstorage.sessionSt_company_clicked) {
          this.router.navigate(['cart', this.webstorage.sessionSt_company_clicked]);
        } else {
          this.router.navigate(['home']);
        }
        break;
    }
  }

}
